// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"ea85121e","404":"28a6b989","427":"c69bf4f2","463":"be5d4b31","751":"979fdf5b","787":"4cb63312","945":"b0055509"}[chunkId] + ".chunk.js";
};